import { FormEvent, useEffect, useState } from "react"
import { toast } from "react-toastify"
import { Button, Col, Form, Row } from "react-bootstrap"
import { getUrlSearchParams } from "../../../urlParams"
import { ApiEndpoints, reqPatch, reqPostNew, reqPut } from "../../../../config/apiClient"
import removeAllErrorMsg from "../../../../components/funcRemoveAllErros"
import funcSleep from "../../../../components/funcSleep"
import LoadingModal from "../../../../components/loadingModal"
import { defineValueInInput, disabledInput } from "../../../../components/funcForInput"
import { iNfServicoDto } from "./NFSeServicosPage"

function NFSeServicoEditarPage() {
    const [loading, setLoading] = useState<boolean>(false)
    const [servicoDados, setTipoDados] = useState<iNfServicoDto | any>({})

    useEffect(() => {
        document.title = "Cadastrar NFSe Serviço | OB PORTUS"

        const urlDados = getUrlSearchParams()
        const id = urlDados.get("cod_serv")

        const getDados = async (id:number) => {
            setLoading(true)

            const dados = {
                servico_cod: Number(id)
            }

            const api = await reqPostNew(ApiEndpoints.nfseServicoConsultar, dados)

            if (api.status === 200) {
                const servico:iNfServicoDto = api.data
                setTipoDados(servico)
                defineValueInInput('cod_serv', servico.servico_cod)
                disabledInput('cod_serv', true)
                defineValueInInput('descricao', servico.servico_descricao)
                defineValueInInput('iss', servico.tributos_situacao)
                defineValueInInput('servico_item', servico.servico_item)
                defineValueInInput('servico_subitem', servico.servico_subitem)
                defineValueInInput('servico_descobro_nacional', servico.servico_descobro_nacional)
            }

            setLoading(false)
        }

        if (id !== null) {
            getDados(Number(id))
            document.title = "Editar NFSe Serviço | OB PORTUS"
        }
    }, [])

    function handleSubmit(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault()
        event.stopPropagation()

        removeAllErrorMsg()

        const form:any = event.target
        let formValidado = true

        let dados:iNfServicoDto = {
            id: Object.values(servicoDados).length === 0 ? null : servicoDados.id,
            servico_cod: Object.values(servicoDados).length > 0 ? servicoDados.servico_cod : form.cod_serv.value,
            servico_descricao: form.descricao.value,
            tributos_situacao: Number(form.iss.value),
            servico_item: Number(form.servico_item.value),
            servico_subitem: Number(form.servico_subitem.value),
            servico_descobro_nacional: Number(form.servico_descobro_nacional.value),
        }

        if (dados.servico_cod === "" && dados.servico_cod.length !== 6) {
            form.cod_serv.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.servico_descricao === "") {
            form.descricao.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.servico_item === 0) {
            form.servico_item.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.servico_subitem === 0) {
            form.servico_subitem.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.servico_descobro_nacional === 0) {
            form.servico_descobro_nacional.nextElementSibling.style.display = "block"
            formValidado = false
        }

        console.info(dados)

        if (!formValidado) {
            return
        }

        if (Object.values(servicoDados).length === 0) {
            cadastrar(dados)
        }

        if (Object.values(servicoDados).length > 0) {
            editar(dados)
        }
    
    }

    async function cadastrar(dados:iNfServicoDto) {

        setLoading(true)

        const api = await reqPut(ApiEndpoints.nfseServicoCadastrar, dados)

        if (api.status === 201) {
            console.log(api.data)

            toast.success('Serviço cadastrado com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })

            await funcSleep(500)

            window.location.assign(`/nfse/servicos`)
        }
        setLoading(false)

    }

    async function editar(dados: iNfServicoDto) {
        setLoading(true)

        const api = await reqPatch(ApiEndpoints.nfseServicoEditar, dados)

        if (api.status === 200) {
            console.log(api.data)

            toast.success('Serviço editado com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })

            await funcSleep(500)

            window.location.assign(`/nfse/servicos`)
        }

        setLoading(false)
    }

    async function handleExcluirTipo() {
        if (!window.confirm('Tem certeza que deseja excluir o Serviço?')) {
            return
        }

        const dados = {
            servico_cod: servicoDados.servico_cod
        }

        setLoading(true)

        const api = await reqPostNew(ApiEndpoints.nfseServicoDeletar, dados)

        if (api.status === 200) {
            console.log(api.data)

            toast.success('Serviço excluído com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })

            await funcSleep(500)

            window.location.assign(`/nfse/servicos`)
        }

        setLoading(false)

    }
    
    return (
        <div id="main">
            <LoadingModal show={loading} handleClose={(event:any) => {
                setLoading(!loading)
            }} />
            <div className="div-row-space-between">
            <h1 id="titleMain">NF Serviço</h1>
            <Button variant="secondary" onClick={() => {window.location.assign(`/nfse/servicos`)}}>Voltar</Button>
            </div>
            <br></br>
            <Form id='formNfServico' onSubmit={handleSubmit} noValidate>

                <Row className="mb-15-forms">
                    <Col className="col-6">
                        <Form.Group>
                            <Form.Label>Código:</Form.Label>
                            <Form.Control name='cod_serv' type="text" id='cod_serv' placeholder="" maxLength={6} />
                            <Form.Control.Feedback type="invalid">
                                Informe o Código!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>

                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>ISS Incidencia Municipio Prestador:</Form.Label>
                            <Form.Select name="iss" id="iss" aria-label="">
                                <option value="1">Retido</option>
                                <option value="0">Tributado</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Informe o ISS!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>Item:</Form.Label>
                            <Form.Control name='servico_item' type="number" id='servico_item' placeholder="" maxLength={2} max={2} />
                            <Form.Control.Feedback type="invalid">
                                Informe o Item!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>Sub Item:</Form.Label>
                            <Form.Control name='servico_subitem' type="number" id='servico_subitem' placeholder="" maxLength={2} />
                            <Form.Control.Feedback type="invalid">
                                Informe o Sub Item!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>Descobro Nacional:</Form.Label>
                            <Form.Control name='servico_descobro_nacional' type="number" id='servico_descobro_nacional' placeholder="" maxLength={2} />
                            <Form.Control.Feedback type="invalid">
                                Informe o Descobro Nacional!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    <Col className="col-12">
                        <Form.Group>
                            <Form.Label>Descrição:</Form.Label>
                            <Form.Control name='descricao' type="text" id='descricao' placeholder=""/>
                            <Form.Control.Feedback type="invalid">
                                Informe o Descrição!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                {
                    Object.values(servicoDados).length === 0 &&
                    <Button variant="success" type="submit" disabled={loading}>{loading ? 'Aguarde ...' : 'Cadastrar'}</Button>
                }

                {
                    Object.values(servicoDados).length > 0 &&
                    <Button variant="success" type="submit" disabled={loading} style={{marginRight: '10px'}}>{loading ? 'Aguarde ...' : 'Editar'}</Button>
                }

                {
                    Object.values(servicoDados).length > 0 &&
                    <Button variant="danger" disabled={loading} style={{marginRight: '10px'}} onClick={() => {handleExcluirTipo()}}>{loading ? 'Aguarde ...' : 'Deletar'}</Button>
                }
            </Form>
        </div>
    )
}

export default NFSeServicoEditarPage